import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {OrdersFilter} from '../../../delivery/models/orders-filter.model';
import {OrdersFilterService} from '../../../delivery/services/orders-filter.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {MatDialogRef} from '@angular/material/dialog';
import {Utilities} from 'app/shared/utilities/utilities.model';
import {DL_DASHBOARD, DL_ORDERS_LIST} from '../../../delivery/delivery-routing-roots';
import {ROOT_DELIVERY, ROOT_DELIVERY_ASR} from '../../../app-routing-roots';
import { DELIVERY_ASR_PROFILES, DELIVERY_PROFILES } from 'app/permissions-variables';
import { PermissionService } from '@shared/service/permission.service';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-search-dialog',
	templateUrl: './search-dialog.component.html',
	styleUrls: ['./search-dialog.component.scss']
})
export class SearchDialogComponent implements OnInit {
	static CLOSE_RESEARCH_START: string = 'closeResearchStart';
	@ViewChild('txtSearchIndex') txtSearchIndex: ElementRef;
	cod_typ_states: number[] = [];
	formSearch: FormGroup;
	route: string;
	isDeliveryAsr: boolean;
	isNotDeliveryAsr: boolean;
	private MIN_LENGTH_: number = 6;
	translateContext = TranslateContext;

	constructor(
		public dialogRef: MatDialogRef<SearchDialogComponent>,
		public fb: FormBuilder,
		public router: Router,
		private permissionService: PermissionService,
		public filterService: OrdersFilterService) {

		this.deliveryAsrProfile();

		this.formSearch = this.fb.group({
			txt_search_index: [],
			cod_typ_state: []
		});
	}

	ngOnInit(): void {
		setTimeout(() => {
			this.formSearch.markAsPristine({ onlySelf: false });
			this.formSearch.markAsUntouched({ onlySelf: false });
		}, 100);
	}

	deliveryAsrProfile(): void {
		if (this.permissionService.getCurrentUserPermissions().hasProfile(DELIVERY_ASR_PROFILES)) {
			this.isDeliveryAsr = true;
		} else {
			this.isNotDeliveryAsr = true;
		}

		if (this.isDeliveryAsr) {
			this.cod_typ_states = [1, 3, 6];
			// this.cod_typ_states = [1, 3, 6, 9];
		} else {
			this.cod_typ_states = [1, 3, 5, 6, 7, 9];
		}
	}

	onBlurSearchIndex(event: any, control: string) {
	    Utilities.setAsyncMinLengthValidator(this.formSearch.controls[control], this.MIN_LENGTH_);
	}

	onSubmit(event: any) {
		this.filterService.updateFilter(new OrdersFilter(this.formSearch.value));

		if (this.isDeliveryAsr) {
			this.route = '/' + ROOT_DELIVERY_ASR + '/' + DL_DASHBOARD + '/' + DL_ORDERS_LIST;
		} else {
			this.route = '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD + '/' + DL_ORDERS_LIST;
		}
		this.router.navigate([this.route]);
		this.dialogRef.close(SearchDialogComponent.CLOSE_RESEARCH_START);
	}

	onKeyPress(event: any) {
		if (Utilities.pressedEnter(event)) {
			this.txtSearchIndex.nativeElement.blur();
			const val = this.formSearch.controls['txt_search_index'].value;
			if (Utilities.isVoid(val) || val.toString().length >= this.MIN_LENGTH_) {
				this.onSubmit(null);
			}
		}
	}

}
